// extracted by mini-css-extract-plugin
export default {"list":"TasksList_list__oF84q","list__wrapper":"TasksList_list__wrapper__dGFbP","task":"TasksList_task__u3WXz","selected":"TasksList_selected__G9VzT"};